import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostBinding, Input, Renderer2, ViewChild } from '@angular/core';
import { WIZ_EVENT_TYPE, VALUE_ENTER, VALUE_SPACE, VALUE_DELETE } from '@wizeoo/akm-core-lib';
import {
  IWizItemRenderer,
  WizBaseComponent,
  WizTextInput,
  WizEventManager, WizEvent,
  WizRoot
} from '@wizeoo/akm-component-lib';
import { FeiKeyDef, WizConstants } from '@wizeoo/akm-compute-lib';
 
import { Column } from 'ag-grid-community';
import { AlkEvent } from '../../../../../../framework/events/alk.event';
import { ALK_EVENT_TYPE } from '../../../../../../model/enums';
/**
 * rendu d'un champ key / filterKey dans les formulaires de baselines
 */
@Component({
  selector: 'filter-mass-renderer',
  templateUrl: './filter-mass.renderer.html'
})
export class FilterMassRenderer extends WizBaseComponent implements AfterViewInit, IWizItemRenderer<null, FeiKeyDef> {
  @HostBinding('style.width') elwidth: string = '100%';
  @ViewChild('content', { read: WizTextInput }) content: WizTextInput;

  constructor(public cdref: ChangeDetectorRef, public elementRef: ElementRef, public  renderer: Renderer2) {
    super(cdref,elementRef, renderer)
  }

  owner: null;

  @Input() public model: any = null; // pour éviter deps circulaires

  private _currentValue: string = null;
  @Input() public set currentValue(value: string) {
    // console.log('set currentValue', this._currentValue, value, this.content);
    if(this._currentValue !== value) {
      this._currentValue = value;
      if(!!this.content) { // seulement si instancié
        this.feed();
      }
    }
  }

  public get currentValue(): string {
    return this._currentValue;
  }

  private _data: FeiKeyDef;
  @Input() public set data(fkd: FeiKeyDef) {
    this._data = fkd;
  }

  public get data(): FeiKeyDef {
    return this._data;
  }

  @Input() public widget: any;
  @Input() public column: Column; // la colonne au sens Aggrid pour transmission sur les saisies en masse de filters




  ngAfterViewInit() {
    this.addlisteners();
    // this.feed();
  }

  private addlisteners(): void {
    WizEventManager.addListener(this, this.elementRef, WIZ_EVENT_TYPE.INPUT_RIGHT_CLICK, this.showHidePop); // demande d'ouverture de pop
    WizEventManager.addListener(this, this.elementRef, 'keydown', (e: KeyboardEvent) => this.onKeyDown(e));
    WizEventManager.addListener(this, this.elementRef, WIZ_EVENT_TYPE.CLEAR, this.clear); // clic sur la croix de suppression
  }

  /**
   * Ecouteur sur key down pour check clavier
   * @param event Evènement key down
   */
  private onKeyDown(event: KeyboardEvent): void {
    if(this.wizDisabled) { // pas si disabled
      return;
    }
    // ouverture sur enter / space
    if (event.key === VALUE_SPACE || event.key === VALUE_ENTER) {
      this.showHidePop();
    }

    // delete par suppr
    if (event.key === VALUE_DELETE) {
      this.clear();
    }
  }

  /** delete par la croix */
  private clear(e: any = null): void {
    this.content.wizValue = null;
    this.currentValue = null;
    WizEventManager.dispatchEvent(this.elementRef, new WizEvent(WIZ_EVENT_TYPE.MODEL_UPDATE, this, this.currentValue));
  }


  private feed(): void {
    let rawVal: string = this.currentValue;
    // ici prise en compte des chronos
   //  console.log('feed', rawVal, this.content?.wizValue);

    if (!!rawVal) { // collecte du FreedataValue
        // const freedataValue: FreedataValueVO = this.model.freedataEngine.getFreedataValue(this.data.code, rawVal);
        // éviter ref circulaire
        const freedataValue: any = this.model.freedataEngine.getFreedataValue(this.data.code, rawVal);
        rawVal = freedataValue?.argsObjVO[WizConstants.FIELD_LABEL]; // la valeur du champ pour ce FD  
    } 
    this.content.wizValue = rawVal; // on prend le libellé
    if(this.currentValue && rawVal) {
      // console.log('rawVal', rawVal, this.currentValue);
      WizEventManager.dispatchEvent(this.elementRef, new WizEvent(WIZ_EVENT_TYPE.MODEL_UPDATE, this, this.currentValue));
    }

    this.cdref.markForCheck();
  }

  public showHidePop(e:any = null): void {
    if(!!this.wizDisabled) {
      return;
    }
    
    if(!!this.currentValue) { // on est en mode close
      this.clear();
      return;
    }

    // let popClass: any = PivotCellFilterkeyEditPop;// FilterMassPop; 


    let params: any = { 
      title: '', 
      label: null, 
      value: this.currentValue, 
      column: this.column,
      fkd: this.data, 
      line: null,
      pack: null,
      widget: this.widget, 
      callback: this.backFromFilterPop.bind(this)};
    


    const pos: DOMRect = this.elementRef.nativeElement.getBoundingClientRect();
    /** ouverture de la pop d'édition en masse */
    // dispatch de l'event, sert possiblement pour sélection rapide sur le master, synchro des esclaves
    WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.SHOWHEADERPOP, [params, pos]));




  //  let params: filterPopParams = {
  //     model: this.model,
  //     currentValue: this.currentValue, // la valeur en cours
  //     fkd: this.data,
  //     callback: this.backFromFilterPop.bind(this)
  //   }

    // const choosePop: WizPopUp = new WizPopUp(
    //   popClass,
    //   false,
    //   false,
    //   null,
    //   '400px',
    //   '350px',
    //   params
    // );
    // const pos: DOMRect = this.elementRef.nativeElement.getBoundingClientRect();

    // const bestXY: [number, number] = PopUtils.setPopCoord(pos, choosePop, WIZ_PHYSIC_POSITION.BOTTOM_RIGHT);
    // const x: string = bestXY[0] + 'px';
    // const y: string = bestXY[1] + 'px';
    // const targetPosition: any = { left: x, top: y }; // position physique
    // choosePop.customPosition = targetPosition;

    // if (PopUpManager.exist(choosePop)) { // suppression de l'instance existante
    //   choosePop.hide();
    // }
    // // ouverture de la pop.
    // choosePop.show();
  }

  /** la mise à jour est directe depuis la popUp */
  private backFromFilterPop(datas: any): void {
    let result: string = datas.updates?.value || null;
    
    // console.log('Mass back', value);
    this.currentValue = result;
    this.feed();
  }

  public get niceIcon(): string {
    if(!!this.currentValue) {
      return 'close';
    } else {
      return 'arrow-down';
    }
  }

}
